<div
  data-cy="list-order-info-sidebar"
  class="order-info-sidebar"
  [class.desktop]="platform === platformEnums?.desktop"
  *ngIf="orderViewModel$ | async as orderVm"
>
  <ng-container>
    <div
      class="download-print-container"
      *ngIf="platform === platformEnums?.tablet && showPrintIcon"
    >
      <ng-container>
        <ion-button
          class="btn-download"
          data-cy="download-order-button"
          (click)="downloadOrderClicked()"
          fill="clear"
        >
          <ion-icon name="download-outline"></ion-icon>
          {{ 'i18n.orderPage.download' | translate }}
        </ion-button>
      </ng-container>
      <ion-button
        class="btn-print"
        data-cy="print-order-button"
        (click)="printOrderClicked()"
        fill="clear"
      >
        <ion-icon name="print-outline"></ion-icon>
        {{ 'i18n.orderPage.print' | translate }}
      </ion-button>
      <ng-container>
        <ion-button
          class="btn-share"
          data-cy="share-order-button"
          (click)="shareOrderClicked()"
          fill="clear"
        >
          <ion-icon name="share-social-outline"></ion-icon>
          {{ 'i18n.orderPage.share' | translate }}
        </ion-button>
      </ng-container>
    </div>
  </ng-container>
  <div
    data-cy="list-order-info-sidebar-section"
    class="order-info-sidebar-row order-details-row"
  >
    <div
      *ngIf="
        _isOnMinimumOrderMetFlag &&
          !!_orderHeader &&
          !!orderMinimumDetails &&
          !orderMinimumDetails?.hasOnlyVSItems &&
          (_orderHeader.orderStatus === 'IN_PROGRESS' ||
            _orderHeader.orderStatus === 'SUBMITTED' ||
            _orderHeader.orderStatus === 'SUBMITTED_CREDIT_HOLD' ||
            _orderHeader.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS') &&
          !orderMinimumDetails.isMet;
        else minimumMet
      "
      class="order-minimum-section"
      [class.pronto-day]="isProntoDay"
      data-cy="list-order-minimum-section"
    >
      <div class="order-min-title" *ngIf="!isProntoDay">
        {{
          'i18n.orderInfoSidebar.minOrderRemainingMetForBroadline' | translate
        }}
      </div>
      <div class="order-min-title" *ngIf="isProntoDay">
        {{ 'i18n.orderInfoSidebar.minOrderRemainingMetForPronto' | translate }}
      </div>
      <div class="order-min-amount">
        <span
          *ngIf="
            !orderMinimumDetails.noPriceCustomer &&
            orderMinimumDetails.remainingDollars > 0
          "
        >
          {{ orderMinimumDetails.remainingDollars || 0 | currency }}
        </span>
        <span *ngIf="orderMinimumDetails.noPriceCustomer">
          {{ orderMinimumDetails.customerMinOrderDollars || 0 | currency }}
        </span>
        <span
          *ngIf="
            (orderMinimumDetails.noPriceCustomer ||
              orderMinimumDetails.remainingDollars > 0) &&
            orderMinimumDetails.remainingCases > 0
          "
          class="mini-border"
        >
          |
        </span>
        <span *ngIf="orderMinimumDetails.remainingCases > 0"
          >{{ orderMinimumDetails.remainingCases || 0 }}
          {{ 'i18n.orderPage.cs' | translate }}</span
        >
      </div>
      <div class="order-min-note" *ngIf="isProntoDay">
        {{ 'i18n.orderInfoSidebar.miniOrderCaseQtyShipMsg' | translate }}
      </div>
    </div>
    <ng-template #minimumMet>
      <div
        *ngIf="
          _isOnMinimumOrderMetFlag &&
          !!_orderHeader &&
          !!orderMinimumDetails &&
          !orderMinimumDetails.hasOnlyVSItems &&
          (_orderHeader.orderStatus === 'IN_PROGRESS' ||
            _orderHeader.orderStatus === 'SUBMITTED' ||
            _orderHeader.orderStatus === 'SUBMITTED_CREDIT_HOLD' ||
            _orderHeader.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS') &&
          (orderMinimumDetails.customerMinOrderDollars > 0 ||
            orderMinimumDetails.customerMinOrderCases > 0)
        "
        class="order-minimum-section-met"
        data-cy="list-order-minimum-section"
      >
        <div class="order-min-title order-msg-bold" *ngIf="!isProntoDay">
          {{ 'i18n.orderInfoSidebar.minOrderMet' | translate }}
        </div>
        <div
          class="order-min-title order-msg-bold free-shipping-title"
          *ngIf="isProntoDay"
        >
          {{ 'i18n.orderInfoSidebar.youGotFreeShipping' | translate }}
        </div>

        <div class="truck truck-animation">
          <img src="assets/images/truck-no-wheels.svg" />
          <div class="wheels">
            <div class="wheels-animation wheel1"></div>
            <div class="wheels-animation wheel2"></div>
          </div>
        </div>
      </div>
    </ng-template>
    <div
      class="order-info-subsection-label-container"
      data-cy="list-order-info-details-section"
    >
      <span
        data-cy="list-order-info-sidebar-label"
        class="order-info-subsection-label"
      >
        {{ 'i18n.orderInfoSidebar.orderDetails' | translate }}
      </span>
    </div>
    <div
      class="order-po-section order-info-sidebar-row"
      data-cy="list-order-info-po-section"
    >
      <span>
        {{ 'i18n.orderPage.poNumberFullText' | translate
        }}<span *ngIf="isCustomerRequirePO" class="required-span">*</span>:
      </span>
      <span>
        <a
          #poNumberRef
          *ngIf="
            orderVm.orderHeader.purchaseOrderNumber &&
            orderVm?.orderHeader?.purchaseOrderNumber?.trim().length !== 0
          "
          (click)="!isPoDisabledForPunchOut && presentChangePOPopover()"
          [class.disabled]="isPoDisabledForPunchOut"
          class="add-change-link"
        >
          {{ orderVm.orderHeader.purchaseOrderNumber }}
        </a>
      </span>
      <span
        *ngIf="
          !!orderVm.orderHeader &&
          (!orderVm?.orderHeader?.purchaseOrderNumber ||
            orderVm?.orderHeader?.purchaseOrderNumber?.trim().length === 0)
        "
      >
        <a
          data-cy="add-change-link"
          (click)="!isPoDisabledForPunchOut && presentChangePOPopover()"
          [class.disabled]="isPoDisabledForPunchOut"
          class="add-change-link"
        >
          {{ 'i18n.common.edit' | translate }}
        </a>
      </span>

      <div
        *ngIf="
          isCustomerRequirePO &&
          (!orderVm?.orderHeader?.purchaseOrderNumber ||
            orderVm?.orderHeader?.purchaseOrderNumber?.trim().length === 0)
        "
        class="required-field-error-message"
      >
        {{ 'i18n.common.requiredFieldText' | translate }}
      </div>
    </div>

    <div
      class="border delivery-date-section"
      [ngClass]="{
        'add-space':
          isCustomerRequirePO &&
          (!orderVm?.orderHeader?.purchaseOrderNumber ||
            orderVm?.orderHeader?.purchaseOrderNumber?.trim().length === 0),
      }"
    >
      <span data-cy="list-order-info-sidebar-label">
        {{ 'i18n.orderInfoSidebar.deliveryDate' | translate }}
      </span>
      <span
        *ngIf="!isCart"
        class="date-label-black"
        data-cy="list-order-info-sidebar-text"
      >
        {{
          (_orderHeader?.orderStatus === 'SUBMITTED' ||
          _orderHeader?.orderStatus === 'SUBMITTED_CREDIT_HOLD' ||
          _orderHeader?.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS'
            ? _orderHeader?.confirmedDeliveryDate
            : _orderHeader?.requestedDeliveryDate
          ) | date: 'M/d/yyyy' : 'GMT'
        }}
      </span>

      <ng-container
        *ngIf="_orderHeader?.orderType !== 'VS'; else directOrderDeliveryDate"
      >
        <a
          *ngIf="isCart"
          class="date-label-green"
          data-cy="list-order-info-sidebar-text"
          (click)="changeDeliveryDateClicked($event)"
        >
          {{
            (_orderHeader?.orderStatus === 'SUBMITTED' ||
            _orderHeader?.orderStatus === 'SUBMITTED_CREDIT_HOLD' ||
            _orderHeader?.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS'
              ? _orderHeader?.confirmedDeliveryDate
              : _orderHeader?.requestedDeliveryDate
            ) | date: 'M/d/yyyy' : 'GMT'
          }}
        </a></ng-container
      >
      <ng-template #directOrderDeliveryDate>
        <span class="date-label-black" data-cy="direct-order-info-sidebar-text">
          {{
            (_orderHeader?.orderStatus === 'SUBMITTED' ||
            _orderHeader?.orderStatus === 'SUBMITTED_CREDIT_HOLD' ||
            _orderHeader?.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS'
              ? _orderHeader?.confirmedDeliveryDate
              : _orderHeader?.requestedDeliveryDate
            ) | date: 'M/d/yyyy' : 'GMT'
          }}
        </span>
      </ng-template>
    </div>
  </div>
  <div
    data-cy="list-order-info-sidebar-section"
    class="order-info-sidebar-row order-cases-eaches-row"
  >
    <div class="cases-eaches-item" data-cy="list-order-info-cases-section">
      <span data-cy="list-order-info-sidebar-label">
        {{ 'i18n.orderInfoSidebar.totalCases' | translate }}
      </span>
      <span data-cy="list-order-info-sidebar-text">
        {{ _orderItemTallies?.totalCases || 0 }}
        {{ 'i18n.common.cs' | translate }}
      </span>
    </div>
    <div class="cases-eaches-item" data-cy="list-order-info-eaches-section">
      <span data-cy="list-order-info-sidebar-label">
        {{ 'i18n.orderInfoSidebar.totalEaches' | translate }}
      </span>
      <span data-cy="list-order-info-sidebar-text">
        {{ _orderItemTallies?.totalEaches || 0 }}
        {{ 'i18n.common.ea' | translate }}
      </span>
    </div>
    <div class="cases-eaches-item" data-cy="list-order-info-weight-section">
      <span data-cy="list-order-info-sidebar-label">
        {{ 'i18n.orderPage.orderWeight' | translate }}
      </span>
      <span data-cy="list-order-info-sidebar-weight-text">
        {{ !!_orderHeader ? (orderWeight$ | async | number: '1.1-2') : 0.0 }}

        {{ 'i18n.orderPage.lb' | translate }}
      </span>
    </div>
    <div class="cases-eaches-divider" data-cy="list-order-info-divider">
      <ion-item-divider> </ion-item-divider>
    </div>
    <div
      class="cases-eaches-item border"
      data-cy="list-order-info-subtotal-section"
    >
      <span data-cy="list-order-info-sidebar-label">
        {{ 'i18n.orderInfoSidebar.subtotal' | translate }}
      </span>
      <span data-cy="lists-order-info-sidebar-text">
        {{ totalPrice$ | async | currency }}
      </span>
    </div>
  </div>
  <div class="order-info-sidebar-row order-total-row">
    <span data-cy="list-order-info-sidebar-label">
      {{ 'i18n.orderInfoSidebar.orderTotal' | translate }}
    </span>
    <span data-cy="lists-order-info-sidebar-text">
      {{ totalPrice$ | async | currency }}
    </span>
  </div>

  <div data-cy="list-order-info-sidebar-section" class="order-cases-eaches-row">
    <div
      *ngIf="isCart"
      class="shipping-savings-text"
      data-cy="list-order-info-shipping-savings-section"
    >
      <span data-cy="list-order-info-sidebar-label">
        {{ 'i18n.orderInfoSidebar.shippingSavings' | translate }}
      </span>
      <span class="shipping-savings-text-right">
        {{ shippingSavings || 0 | currency }}
        <ng-container
          *ngIf="
            platform !== platformEnums?.desktop;
            else shippingSavingsDesktop
          "
        >
          <ion-icon
            id="click-trigger"
            name="information-circle-outline"
            data-cy="order-sidebar-shipping-savings-info-icon"
          ></ion-icon>
        </ng-container>
        <ng-template #shippingSavingsDesktop>
          <ion-icon
            id="hover-trigger"
            name="information-circle-outline"
            data-cy="order-sidebar-shipping-savings-info-icon"
          ></ion-icon>
        </ng-template>
      </span>
    </div>
  </div>

  <div class="order-info-button">
    <ion-button
      data-cy="list-review-order-button"
      *ngIf="(isList || !isList) && !isCart"
      class="usf-fill-green-button"
      (click)="routeTo('/order')"
    >
      <ng-container *ngIf="isList && !isCart">
        {{ 'i18n.orderInfoSidebar.reviewOrder' | translate }}
      </ng-container>
      <ng-container *ngIf="!isList && !isCart">
        {{ 'i18n.orderInfoSidebar.backToCurrentOrder' | translate }}
      </ng-container>
    </ion-button>

    <ng-container *ngIf="!isList && isCart">
      <ion-button
        data-cy="list-submit-order-button"
        [disabled]="(enableSubmitButton$ | async) || disableSubmit"
        class="submit-button"
        [ngClass]="
          (enableSubmitButton$ | async) ||
          disableSubmit ||
          (isCustomerRequirePO &&
            (!orderVm?.orderHeader?.purchaseOrderNumber ||
              orderVm?.orderHeader?.purchaseOrderNumber?.trim().length === 0))
            ? 'usf-fill-disabled-button'
            : 'usf-fill-green-button'
        "
        (click)="submitOrderClicked($event)"
      >
        {{
          submitButtonText
            ? submitButtonText
            : ('i18n.orderInfoSidebar.submitOrder' | translate)
        }}
      </ion-button>
      <ion-button
        *ngIf="
          _orderHeader?.orderStatus === 'SUBMITTED' ||
          _orderHeader?.orderStatus === 'SUBMITTED_CREDIT_HOLD' ||
          _orderHeader?.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS'
        "
        class="usf-outline-green-button header-button"
        (click)="discardOrderPopUpModalOpen()"
        data-cy="discard-edits-button"
      >
        {{ 'i18n.orderInfoSidebar.discardEdits' | translate }}
      </ion-button>
    </ng-container>

    <a
      *ngIf="!isList && isCart"
      (click)="cancelOrderClicked()"
      class="cancel-order-button"
      data-cy="cancel-order-button"
      [hidden]="
        (enableSubmitButton$ | async) && _orderHeader?.tandemOrderNumber
      "
    >
      {{ 'i18n.orderPage.cancelOrder' | translate }}
    </a>
  </div>

  <!-- Quick Entry Widget -->
  <ng-container
    *ngIf="(orderService.restrictNavigationForCurrentOrder$ | async) !== true"
  >
    <div id="quick-entry-accordion">
      <ion-accordion-group [animated]="false">
        <ion-accordion value="first">
          <ion-item slot="header" color="none">
            <label>
              {{
                'i18n.orderInfoSidebar.quickOrderWidget.quickEntryTitle'
                  | translate
              }}</label
            >
          </ion-item>
          <div class="ion-padding" slot="content">
            <div id="quick-order-form">
              <div>
                <div>
                  {{
                    'i18n.orderInfoSidebar.quickOrderWidget.productNumTitle'
                      | translate
                  }}
                </div>
                <div>
                  <ion-input
                    #productSearchField
                    id="productSearchField"
                    numeric
                    maxlength="7"
                    (keydown.enter)="handleEnterKey($event, false)"
                    (keydown.tab)="handleTabKey($event, false)"
                    (ionBlur)="qoeProductSearchHandler()"
                    [(ngModel)]="productNumberSearchInput"
                    (paste)="pasteFired($event, false)"
                    data-cy="qoe-product-search-input"
                    disabled="{{ !!cpnInput && cpnInput !== '' }}"
                  >
                  </ion-input>
                  <ng-container *ngIf="productSearchLoadingSpinner === true">
                    <ion-spinner
                      name="circles"
                      class="qoe-product-spinner"
                    ></ion-spinner>
                  </ng-container>
                </div>
              </div>
              <div>
                <div>
                  {{
                    'i18n.orderInfoSidebar.quickOrderWidget.custProdNumTitle'
                      | translate
                  }}
                </div>
                <ion-input
                  #customerProductNumberSearchField
                  id="customerProductNumberSearchField"
                  modifiedAlphanumeric
                  type="text"
                  maxlength="20"
                  (keydown.enter)="handleEnterKey($event, true)"
                  (keydown.tab)="handleTabKey($event, true)"
                  (ionBlur)="qoeCustomerProductSearchHandler()"
                  [(ngModel)]="customerProductNumberSearchInput"
                  (paste)="pasteFired($event, true)"
                  data-cy="qoe-customer-num-search-input"
                  disabled="{{ isProductSearch }}"
                ></ion-input>
                <ng-container
                  *ngIf="customerProductSearchLoadingSpinner === true"
                >
                  <ion-spinner
                    name="circles"
                    class="qoe-product-spinner"
                  ></ion-spinner>
                </ng-container>
              </div>
            </div>
            <div
              class="qoe-product-added-message"
              *ngIf="!!productAddedSuccessMessage"
              data-cy="qoe-product-added-success-message"
            >
              <span> {{ this.productAddedSuccessMessage }}</span>
              <ion-icon name="checkmark-circle-outline"></ion-icon>
            </div>
            <div
              class="qoe-error-message"
              data-cy="qoe-error-message"
              *ngIf="
                quickOrderItem?.product?.productCardWarningMsg?.display ===
                  true ||
                  quickOrderItem?.product?.notFound === true ||
                  cpnNotFound;
                else checkForError
              "
            >
              <div class="qoe-error-inner">
                <span
                  class="qoe-warning-message-primary-text"
                  data-cy="qoe-warning-message-primary-text"
                  >{{
                    this.getProductWarningMessage()?.primaryText | translate
                  }}
                </span>
                <span class="qoe-warning-message-secondary-text">{{
                  this.getProductWarningMessage()?.secondaryText | translate
                }}</span>
                <span
                  *ngIf="this.getProductWarningMessage()?.secondaryTextDate"
                  class="qoe-warning-message-secondary-text-date"
                  data-cy="qoe-warning-message-secondary-text-date"
                >
                  {{ this.getProductWarningMessage()?.secondaryTextDate }}
                </span>
                <span
                  class="qoe-warning-message-boldtext"
                  data-cy="qoe-warning-message-boldtext"
                >
                  <b>
                    {{
                      this.getProductWarningMessage()?.boldedText | translate
                    }}</b
                  >
                </span>
              </div>
            </div>
            <ng-template #checkForError>
              <div
                class="qoe-error-message"
                *ngIf="quickOrderItem?.loadingError === true"
                data-cy="qoe-error-tryagain-message"
              >
                <div class="qoe-error-inner">
                  <span>
                    {{
                      'i18n.orderInfoSidebar.quickOrderWidget.errorLoading'
                        | translate
                    }}&nbsp;
                  </span>
                  {{
                    'i18n.orderInfoSidebar.quickOrderWidget.pleaseTryAgain'
                      | translate
                  }}
                </div>
              </div>
            </ng-template>

            <div
              class="qoe-product-desc"
              *ngIf="quickOrderItem?.product?.summary?.productDescTxtl"
              data-cy="qoe-product-desc-text"
            >
              {{
                quickOrderItem?.product?.summary?.productDescTxtl
                  | acronymTitleCase
              }}
            </div>
            <ng-container *ngIf="showQuantityInputs">
              <div
                id="qoe-quantity-form"
                [ngClass]="
                  platformService?.platformType === 'tablet' ? 'tablet' : ''
                "
              >
                <div
                  (keydown.enter)="handleQuantityKeydown($event, false)"
                  (keydown.tab)="handleQuantityKeydown($event, false)"
                >
                  <app-quantity-input
                    #casesInput
                    [quantity]="qoeQuantityCS"
                    [productNumber]="quickOrderItem?.product?.productNumber"
                    [isOffline]="false === (panAppState.online$ | async)"
                    [isDisabled]="
                      platform === platformEnums?.desktop &&
                      (newProductNumberSearch || newCustomerProductNumberSearch)
                    "
                    [isEaches]="false"
                    [platform]="platform"
                    (quantityUpdateEmitter)="changeQuantityHandler($event)"
                    [isProductCard]="false"
                    data-cy="qoe-units-input"
                  ></app-quantity-input>
                  <span>CS</span>
                </div>
                <div
                  (keydown.enter)="handleQuantityKeydown($event, true)"
                  (keydown.tab)="handleQuantityKeydown($event, true)"
                >
                  <ng-container
                    *ngIf="quickOrderItem?.product?.summary?.breakable"
                  >
                    <app-quantity-input
                      #eachesInput
                      [quantity]="qoeQuantityEA"
                      [productNumber]="quickOrderItem?.product?.productNumber"
                      [isOffline]="false === (panAppState.online$ | async)"
                      [isDisabled]="
                        platform === platformEnums?.desktop &&
                        (newProductNumberSearch ||
                          newCustomerProductNumberSearch)
                      "
                      [isEaches]="true"
                      [platform]="platform"
                      (quantityUpdateEmitter)="changeQuantityHandler($event)"
                      [isProductCard]="false"
                      data-cy="qoe-eaches-input"
                    ></app-quantity-input>
                    <span>EA</span>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </ion-accordion>
      </ion-accordion-group>
    </div>
  </ng-container>
</div>

<!-- Tablet Shipping Savings -->
<ng-container *ngIf="touchPopoverReady">
  <ion-popover
    *ngIf="platform !== platformEnums?.desktop"
    trigger="click-trigger"
    triggerAction="click"
    class="direct-shipping-savings-popover"
    mode="ios"
  >
    <ng-template>
      <ng-container *ngTemplateOutlet="shippingSavingsContent"></ng-container>
    </ng-template>
  </ion-popover>
</ng-container>
<!-- End Tablet Shipping Savings -->

<!-- Desktop Shipping Savings -->
<ng-container *ngIf="desktopPopoverReady">
  <ion-popover
    *ngIf="platform === platformEnums?.desktop"
    trigger="hover-trigger"
    triggerAction="hover"
    class="direct-shipping-savings-popover"
    mode="ios"
  >
    <ng-template>
      <ng-container *ngTemplateOutlet="shippingSavingsContent"></ng-container>
    </ng-template>
  </ion-popover>
</ng-container>
<!-- End Desktop Shipping Savings -->

<ng-template #shippingSavingsContent>
  <div class="shipping-savings-popover" data-cy="direct-buy-more-popover">
    <h4 data-cy="direct-buy-more-title">
      {{ 'i18n.orderPage.shippingSavingsPopover.directBuy' | translate }}
    </h4>
    <p data-cy="direct-buy-more-content">
      {{ 'i18n.orderPage.shippingSavingsPopover.directBuyText' | translate }}
    </p>
    <ng-container
      *ngIf="
        !(
          isShipmentTypeVendor &&
          (_orderHeader?.orderStatus === 'SUBMITTED' ||
            _orderHeader?.orderStatus === 'SUBMITTED_CREDIT_HOLD' ||
            _orderHeader?.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS')
        )
      "
    >
      <ion-button
        class="usf-fill-green-button"
        data-cy="show-all-savings-button"
        (click)="goToDirect()"
        >{{
          'i18n.orderPage.shippingSavingsPopover.shopAllDirect' | translate
        }}</ion-button
      >
    </ng-container>
  </div>
</ng-template>
